import React from 'react';
import { Upload, CheckCircle } from 'lucide-react';

const Step3Documents = ({
 formData,
 errors,
 uploadProgress,
 handleFileUpload,
 handleInputChange,
 toggleDayAvailability
}) => {
 const renderFileUpload = (field, label, description = null) => (
 <div>
 <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1.5 sm:mb-2">
 {label} * (PDF or Image)
 </label>
 {description && (
 <p className="text-xs sm:text-sm text-gray-600 mb-2 sm:mb-3">
 {description}
 </p>
 )}
 <div
 className={`border-2 border-dashed rounded-lg p-4 sm:p-6 text-center transition-colors ${ errors[field] ? 'border-red-300 bg-red-50/40' : 'border-gray-300 hover:border-gray-400' }`}
 >
 <input
 type="file"
 accept=".pdf,.jpg,.jpeg,.png"
 onChange={(e) => handleFileUpload(field, e.target.files[0])}
 className="hidden"
 id={field}
 required
 />
 <label htmlFor={field} className="cursor-pointer">
 <Upload className="mx-auto h-8 w-8 sm:h-12 sm:w-12 text-gray-400" />
 <p className="mt-2 text-xs sm:text-sm text-gray-600">
 Click to upload or drag and drop
 </p>
 <p className="text-xs text-gray-500">PDF, PNG, JPG up to 10MB · Required</p>
 </label>
 </div>
 {formData[field] && (
 <div className="mt-2 sm:mt-3 p-2 sm:p-3 bg-green-50 border border-green-200 rounded-lg">
 <div className="flex items-center">
 <CheckCircle className="h-4 w-4 sm:h-5 sm:w-5 text-green-500 mr-2 flex-shrink-0" />
 <div className="flex-1 min-w-0">
 <p className="text-xs sm:text-sm font-medium text-green-800 truncate">
 {formData[field].name}
 </p>
 <p className="text-xs text-green-600">
 {(formData[field].size / 1024 / 1024).toFixed(2)} MB • {formData[field].mime_type}
 </p>
 </div>
 <button
 type="button"
 onClick={() => {
 handleInputChange(field, null);
 }}
 className="text-red-500 hover:text-red-700 text-xs sm:text-sm ml-2 flex-shrink-0"
 >
 Remove
 </button>
 </div>
 </div>
 )}
 {uploadProgress[field] !== null && uploadProgress[field] !== undefined && (
 <div className="mt-2">
 <div className="bg-gray-200 rounded-full h-2">
 <div 
 className="bg-ink h-2 rounded-full transition-all duration-300"
 style={{ width: `${uploadProgress[field]}%` }}
 ></div>
 </div>
 </div>
 )}
 {errors[field] && (
 <p className="mt-1 text-xs sm:text-sm text-red-600">{errors[field]}</p>
 )}
 </div>
 );

 return (
 <div className="space-y-4 sm:space-y-6">
 <div>
 <h3 className="text-base sm:text-lg font-medium text-gray-900 mb-2 sm:mb-4">Documents</h3>
 <p className="text-xs sm:text-sm text-gray-600 mb-4 sm:mb-6">
 Upload all three documents below — each one is required before you can continue.
 </p>
 </div>

 <div className="space-y-4 sm:space-y-6">
 {renderFileUpload('business_license', 'Business License')}
 {renderFileUpload('insurance_certificate', 'Insurance Certificate')}
 {renderFileUpload(
 'id_document', 
 'ID Document',
 'Upload a valid government-issued ID such as driving license, passport, national ID, or other official identification document.'
 )}
 </div>

 {/* Additional Information */}
 <div className="space-y-3 sm:space-y-4 pt-4 border-t border-gray-200">
 <h4 className="text-sm sm:text-md font-medium text-gray-900">Additional Information</h4>
 
 <div>
 <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1.5 sm:mb-2">
 Insurance Details
 </label>
 <textarea
 value={formData.insurance_info}
 onChange={(e) => handleInputChange('insurance_info', e.target.value)}
 rows={3}
 className="w-full px-3 py-1.5 text-xs sm:text-base border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-ink"
 placeholder="Provide details about your insurance coverage..."
 />
 </div>

 <div>
 <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2 sm:mb-3">
 Service Availability Days
 </label>
 <p className="text-xs sm:text-sm text-gray-600 mb-3 sm:mb-4">
 Select which days you're available for bookings. Services can run all day on selected days.
 </p>
 <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3">
 {Object.entries(formData.business_hours).map(([day, dayData]) => (
 <div key={day} className="flex items-center space-x-2 p-2 sm:p-3 border border-gray-200 rounded-lg hover:bg-surface-muted">
 <input
 type="checkbox"
 checked={dayData.available}
 onChange={() => toggleDayAvailability(day)}
 className="h-4 w-4 text-ink focus:ring-ink border-gray-300 rounded flex-shrink-0"
 />
 <span className="text-xs sm:text-sm font-medium text-gray-700 capitalize">
 {day}
 </span>
 </div>
 ))}
 </div>
 </div>

 <div>
 <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1.5 sm:mb-2">
 References
 </label>
 <textarea
 value={formData.references}
 onChange={(e) => handleInputChange('references', e.target.value)}
 rows={3}
 className="w-full px-3 py-1.5 text-xs sm:text-base border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-ink"
 placeholder="Provide contact information for professional references..."
 />
 </div>
 </div>
 </div>
 );
};

export default Step3Documents;


